import { Text } from "@clipboard-health/ui-components";
import { Box, Stack, type SxProps } from "@mui/material";

interface StructuredInfoSectionProps {
  title: string;
  children: React.ReactNode;
  sx?: SxProps;
}

export function StructuredInfoSection({ title, children, sx }: StructuredInfoSectionProps) {
  return (
    <Stack direction="row" spacing={4} alignItems="flex-start" sx={{ ...sx }}>
      <Box sx={{ minWidth: "6rem", flexShrink: 0 }}>
        <Text bold variant="body1" sx={{ color: (theme) => theme.palette.text.primary }}>
          {title}
        </Text>
      </Box>
      <Stack spacing={1} flex={1}>
        {children}
      </Stack>
    </Stack>
  );
}
